/* eslint-disable react/jsx-props-no-spreading -- each state shows its own actions with the same props */
import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { calendarStateOf } from './calendarFilterModel';
import type { PostStateActionsProps } from './dayPanelTypes';
import { DraftActions } from './DraftActions';
import { FailedActions } from './FailedActions';
import { NeedsYouActions } from './NeedsYouActions';
import { PublishedActions } from './PublishedActions';
import { ScheduledActions } from './ScheduledActions';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './DayPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The actions of a post, one part per state (design b1-b5, b10). A post that goes out now has no
 * action. A canceled post has only Delete.
 */
const DayPanelActionsComponent: React.FC<PostStateActionsProps> = (props) => {
  const intl = useIntl();
  const { post, onAskDelete } = props;
  if (post.status === 'publishing') {
    return (
      <div className={styles.dpBody}>
        <span className={styles.tiny}>
          {intl.formatMessage({
            id: 'app.sml.promote.post.publishingNote',
            defaultMessage: 'This post is going out right now, so it cannot be changed.',
          })}
        </span>
      </div>
    );
  }
  switch (calendarStateOf(post.status)) {
    case 'needsYou':
      return <NeedsYouActions {...props} />;
    case 'draft':
      return <DraftActions {...props} />;
    case 'failed':
      return <FailedActions {...props} />;
    case 'published':
      return <PublishedActions {...props} />;
    case 'canceled':
      return (
        <div className={styles.dpActs}>
          <button type="button" className={styles.linkbtn} onClick={() => onAskDelete(post)}>
            {intl.formatMessage({ id: 'app.sml.promote.calendar.delete', defaultMessage: 'Delete this post' })}
          </button>
        </div>
      );
    case 'scheduled':
    default:
      return <ScheduledActions {...props} />;
  }
};

export const DayPanelActions = TypedMemo(DayPanelActionsComponent);
